
import u from "umbrellajs"
import IntlTelInput from "plugins/intl_tel_input"
import Promise from "plugins/bluebird"
import {
  init as initShareModal,
} from "concepts/new_development_buildings/contact/request/box/components/share_modal/index"

import Authentication_manager from "app/authentication/manager"
import Notifier from "app/notifier/index"
import shortlist from "app/listings/shortlist"
import Formatter from "app/numbers/formatter"
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"
import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"

import Goals from "app/tracking/goals/track"
import FacebookPixel_Event from "app/tracking/facebook-pixel/event"

import {
  refreshAndUpdateComponentPromise,
} from "app/authentication/remote_state"

import {
  create as create_user,
  ResultTypeEnums as CreateUserResultTypes,
} from "app/resources/users/create/index"

import {
  getContactInfoData,
  setContactInfoData,
} from "app/local_storages/contact_info_storage"

import {
  create as createListingContactRequests,
  ResultTypeEnums as createListingContactRequestResultTypes,
} from "app/resources/listing_contact_requests/create/index"

import {
  captureMessage,
  captureException,
} from "app/error_reporting"

import {
  isPresentString,
} from "app/utils/type_checking"

import {
  isSignedIn,
} from "app/authentication/state"

import {
  trackSignUp,
} from "app/authentication/tracking"


import I18n from "plugins/i18n-js"

const RejectionReasons = {
  ERROR_REPORTED:       "ERROR_REPORTED",
  FAILURE_CASE_HANDLED: "FAILURE_CASE_HANDLED",
}

interface InputSelector {
  scope?: string | HTMLElement,

  form?: string | HTMLElement,

  contact_name_input?: string | HTMLElement,
  contact_email_address_input?: string | HTMLElement,
  contact_phone_number_input?: string | HTMLElement,
  contact_phone_number_dial_code?: string | HTMLElement,
  additional_message_input?: string | HTMLElement,
  reject_promotions_container?: string | HTMLElement,
  reject_promotions_input?: string | HTMLElement,

  submit_button?: string,
}
const DEFAULT_SELECTOR = {
  scope: ".cell-new-development-contact-request-box",

  form: "form",

  contact_name_input:
    ".cell-new-development-contact-request-box__input-contact_name",
  contact_email_address_input:
    ".cell-new-development-contact-request-box__input-contact_email_address",
  contact_phone_number_input:
    ".cell-new-development-contact-request-box__input-contact_phone_number",
  contact_phone_number_dial_code:
    ".iti__selected-dial-code",
  additional_message_input:
    ".cell-new-development-contact-request-box__input--message",
  reject_promotions_container:
    ".cell-new-development-contact-request-box__reject_promotions--container",
  reject_promotions_input:
    ".cell-new-development-contact-request-box__reject_promotions",
  submit_button: "input[type=\"submit\"]",
}

const PAGE_EXPAND_CLASS = "page--filter--freeze"

const init = (selector?: InputSelector) => {
  const merged_selector = Object.assign({}, DEFAULT_SELECTOR, selector)
  const $scope = u(merged_selector.scope)
  const $forms = $scope.find(merged_selector.form)
  const body_el = document.querySelector("body") as HTMLElement

  $forms.each((el) => {
    const $one_form = u(el)

    const listing_id = $one_form.data("listing-id")

    const $contact_name_input =
      $one_form.find(merged_selector.contact_name_input)
    const $contact_email_address_input =
      $one_form.find(merged_selector.contact_email_address_input)
    const $contact_phone_number_input =
      $one_form.find(merged_selector.contact_phone_number_input)
    const $additional_message_input =
      $one_form.find(merged_selector.additional_message_input)

    const $reject_promotions_container =
      $one_form.find(merged_selector.reject_promotions_container)
    const $reject_promotions_input =
      $one_form.find(merged_selector.reject_promotions_input)

    const $submit_button =
      $one_form.find(
        merged_selector.submit_button,
      )

    IntlTelInput.getIntlTelInput()
    .then((intlTelInput) => {
      WaitObjectByPathPromise("window._spacious_main_css_loaded")
      .then(() => {
        $contact_phone_number_input.each((phone_input_el) => {
          intlTelInput(phone_input_el, {
            loadUtilsOnInit:    () => import("intl-tel-input/build/js/utils"),
            allowDropdown:      true,
            autoInsertDialCode: true,
            autoPlaceholder:    "polite",
            nationalMode:       false,
            separateDialCode:   true,

            localizedCountries: (I18n.t("plugins.intl_tel_input.iso2_code") as any),
            preferredCountries: [
              "hk",
              "tw",
              "cn",
              "mo",
              "jp",
              "us",
              "gb",
            ],
            initialCountry: "auto",
            geoIpLookup:    (callback: (c: string) => void) => {
              q_ajax_3({
                url:      "/my_country_code",
                method:   "GET",
                dataType: "json",
              })
              .then(({data}) => {
                const countryCode = (data?.country_code) ? data.country_code : ""
                callback(countryCode)
              })
              .catch(() => {
                // Do nothing
              })
              .done()
            },
          })

          u(phone_input_el).on("open:countrydropdown", () => {
            body_el.classList.add(PAGE_EXPAND_CLASS)
          })

          u(phone_input_el).on("close:countrydropdown", () => {
            body_el.classList.remove(PAGE_EXPAND_CLASS)
          })
        })
      })
      .done()
    })

    $one_form.on("submit", (e) => {
      e.preventDefault()

      import(
        "libphonenumber-js"
      )
      .then(({isValidNumber: isValidPhoneNumber}) => {
        const local_contact_info_data = getContactInfoData()

        const contact_email_address_input_val: string | null =
          ($contact_email_address_input.first() as HTMLInputElement).value
        const contact_phone_number_dial_code_text: string | null =
          $one_form.find(merged_selector.contact_phone_number_dial_code).text()
        const contact_phone_number_input_val: string | null =
          Formatter.phoneNumber(
            ($contact_phone_number_input.first() as HTMLInputElement).value,
            contact_phone_number_dial_code_text,
          )

        const contact_name_input_val: string | null =
          ($contact_name_input.first() as HTMLInputElement).value
        const additional_message_val: string | null =
          ($additional_message_input.first() as HTMLInputElement).value
        const reject_promotions_input_val: boolean =
          ($reject_promotions_input.first() as HTMLInputElement).checked

        $submit_button.each((submit_btn_el) => {
          (submit_btn_el as HTMLInputElement).disabled = true
        })

        if (! isPresentString(contact_email_address_input_val)) {
          Notifier.showError(
            I18n.t("js.app.notifier.defaults.input_email_address_invalid"),
          )
          $submit_button.each((submit_btn_el) => {
            (submit_btn_el as HTMLInputElement).disabled = false
          })
          return
        }
        if (! isPresentString(contact_phone_number_input_val)) {
          Notifier.showError(
            I18n.t("js.app.notifier.defaults.input_phone_no_invalid"),
          )
          $submit_button.each((submit_btn_el) => {
            (submit_btn_el as HTMLInputElement).disabled = false
          })
          return
        }
        if (contact_phone_number_input_val == null || !isValidPhoneNumber(contact_phone_number_input_val)) {
          Notifier.showError(
            I18n.t("js.app.notifier.defaults.input_phone_no_invalid"),
          )
          $submit_button.each((submit_btn_el) => {
            (submit_btn_el as HTMLInputElement).disabled = false
          })
          return
        }

        // Some hack to make flow happy zzz
        const valid_contact_email_address_input_val: string =
          contact_email_address_input_val || ""
        const valid_contact_phone_number_input_val: string =
          contact_phone_number_input_val || ""

        Promise.resolve()
        .then(() => {
          if (isSignedIn()) {
            return Promise.resolve()
          }

          return create_user({
            authentication_handle: local_contact_info_data.user_authentication_handle || valid_contact_email_address_input_val,
            email_address:         valid_contact_email_address_input_val,
            sign_in_on_success:    true,
          })
          .then(({result_type}) => {
            switch (result_type) {
              case CreateUserResultTypes.SUCCESS:
                trackSignUp()
                refreshAndUpdateComponentPromise().done()
                shortlist(listing_id, {
                  show_auth_modal_on_fail: false,
                })
                return
              case CreateUserResultTypes.CONFLICT:
                return
              default:
                captureMessage(
                  `unexpected/unhandled result_type: <${result_type}>`,
                  {
                    source_file_path:
                      "concepts/new_development_buildings/contact/request/box/components/remote_submit_form/index",
                  }
                )
                throw RejectionReasons.ERROR_REPORTED
            }
          })
        })
        .then(() => {
          return createListingContactRequests({
            user_authentication_handle: local_contact_info_data.user_authentication_handle || valid_contact_email_address_input_val,

            listing_id: listing_id,

            listing_contact_request_attributes: {
              requester_name:
              contact_name_input_val,

              requester_email_address:
              valid_contact_email_address_input_val,

              requester_phone_number:
              valid_contact_phone_number_input_val,

              additional_message:
              additional_message_val,
            },
            reject_promotions: reject_promotions_input_val,
          })
        })
        .then(({result_type, data}) => {
          if (result_type === createListingContactRequestResultTypes.UNAUTHENTICATED) {
            Notifier.showWarning(I18n.t("devise.failure.unauthenticated"))
            throw RejectionReasons.FAILURE_CASE_HANDLED
          }

          if (result_type === createListingContactRequestResultTypes.UNAUTHORIZED) {
            Notifier.showWarning(I18n.t("app_resources.listing_contact_requests_create.errors.unauthorized"))
            throw RejectionReasons.FAILURE_CASE_HANDLED
          }

          // Since enquiry already sent
          // We prevent further enquiries to be created
          // And no modal shown
          if (result_type === createListingContactRequestResultTypes.CONFLICTING_RESOURCE_ALREADY_EXISTS) {
            Notifier.showWarning(I18n.t("app_resources.listing_contact_requests_create.errors.conflicting_resource_already_exists"))
            throw RejectionReasons.FAILURE_CASE_HANDLED
          }

          if (result_type === createListingContactRequestResultTypes.LISTING_CONTACT_EMAIL_OR_PHONE_ABSENT) {
            Notifier.showWarning(I18n.t("app_resources.listing_contact_requests_create.errors.contact_email_or_phone_absent"))
            throw RejectionReasons.FAILURE_CASE_HANDLED
          }

          if (result_type === createListingContactRequestResultTypes.INVALID_CONTACT_PHONE_NUMBER) {
            Notifier.showError(I18n.t("app_resources.listing_contact_requests_create.errors.invalid_contact_phone_number"))
            throw RejectionReasons.FAILURE_CASE_HANDLED
          }

          if (result_type !== createListingContactRequestResultTypes.SUCCESS) {
            captureMessage(
              `unexpected result_type from createListingContactRequests: ${result_type}`,
              {
                source_file_path:
                  "concepts/new_development_buildings/contact/request/box/components/remote_submit_form/index",
                valid_contact_email_address_input_val:
                  valid_contact_email_address_input_val,
                valid_contact_phone_number_input_val:
                  valid_contact_phone_number_input_val,
              }
            )
            throw RejectionReasons.ERROR_REPORTED
          }

          return data
        })
        .then(() => {
          // Update cached contact info
          if (isPresentString(contact_name_input_val)) {
            setContactInfoData({
              contact_name: contact_name_input_val,
            })
          }
          if (isPresentString(contact_email_address_input_val)) {
            setContactInfoData({
              contact_email_address: contact_email_address_input_val,
            })
          }
          if (contact_phone_number_input_val != null && isPresentString(contact_phone_number_input_val) && isValidPhoneNumber(contact_phone_number_input_val)) {
            setContactInfoData({
              contact_phone_number: contact_phone_number_input_val,
            })
          }

          Goals.ListingContactByEmail.track(
            Goals.ListingContactByEmail.PropertyTypeLabels.OVERSEAS,
          )
          FacebookPixel_Event.trackCustomEvent("OP-EmailEnquiry")

          Notifier.showSuccess(I18n.t("js.app.notifier.listing_contact_request.successfully_submitted"))

          initShareModal({
            listing_id: listing_id,
          })
        })
        .catch((whatever) => {
          $submit_button.each((submit_btn_el) => {
            (submit_btn_el as HTMLInputElement).disabled = false
          })

          if (whatever === RejectionReasons.FAILURE_CASE_HANDLED) { return }

          Notifier.showError(I18n.t("js.app.notifier.defaults.form_submit_failed"))

          if (whatever === RejectionReasons.ERROR_REPORTED) { return }

          if (whatever instanceof Error) {
            captureException(
              whatever,
              {
                source_file_path:
                  "concepts/new_development_buildings/contact/request/box/components/remote_submit_form/index",
              }
            )
            return
          }

          captureMessage(
            `rejected w/ something unexpected: ${whatever}`,
            {
              source_file_path:
                "concepts/new_development_buildings/contact/request/box/components/remote_submit_form/index",
            }
          )
        })
        .done()
      })
    })

    Authentication_manager.on("sign_up:success:action", () => {
      $reject_promotions_container.html("")
    })

    Authentication_manager.on("sign_in:success:action", () => {
      $reject_promotions_container.html("")
    })
  })
}


export default {init}
